<template>
    <div style="background: #f2f2f2;" v-show="show">
        <common-head active="0" state="1"></common-head>

        <!-- 标题 -->
        <div class="title">
            {{info.match_name}}
        </div>

        <!-- 顶部大图 -->
        <div class="banner" @click="match">
            <img :src="info.match_main_image">
        </div>

        <div class="match" @click="match">
            立即购买
        </div>

        <!-- 内容 -->
        <div class="main">
            <div class="left">
                <div class="cate">
                    <div class="cate-content" @click="change(index)" :class="active==index?'active':''"
                        v-for="(item,index) in cate" :key="index">{{item.cate_name}}</div>
                </div>
            </div>
            <div class="right">
                <div class="content" v-html="content.cate_content"></div>
            </div>
        </div>

        <common-footer></common-footer>
    </div>
</template>

<script>
    import { share } from "@/static/js/share.js";
    import commonHead from '@/components/wap/commonHead.vue';
    import commonFooter from '@/components/wap/commonFooter.vue';
    import { common_match } from '@/api/common.js';

    export default {
        name: 'detail',
        components: {
            commonHead, commonFooter
        },
        data() {
            return {
                show: false,
                info: { match_name: '产品' },
                cate: [],
                active: 0,
            }
        },
        computed: {
            content() {
                if (this.cate.length) {
                    return this.cate[this.active];
                } else {
                    return { cate_content: '' };
                }
            },
        },
        metaInfo() {
            site_name().then(res => {
                document.title = this.info.match_name + '-' + res.site_name;
                return {
                    title: this.info.match_name + '-' + res.site_name,
                    meta: [
                        { name: "keywords", content: "" },
                        { name: "description", content: "" },
                        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' }
                    ],
                }
            });
        },
        created() {
            const id = this.$route.query.id;
            this.get_data(id);
        },
        methods: {
            get_data(id) {
                common_match({ id: id }).then(res => {
                    if (res.code == 1) {
                        this.info = res.data.info;
                        this.cate = res.data.cate;
                        this.show = true;
                        share(window.location.pathname + window.location.search, res.data.info.match_name);
                    }
                });
            },
            change(e) {
                this.active = e;
            },
            match() {
                window.location.href = this.info.match_url;
            },
        },
    }
</script>
<style scoped>
    .banner {
        padding:0 20px;
        width: calc(100% - 40px);
        margin: 0 auto;
    }
    .banner img{
        width: 100%;
    }

    .main {
        padding:0 20px;
        width: calc(100% - 40px);
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 50px;
        border-radius: 20px;
        position: relative;
    }

    .left {
        width: 100%;
        vertical-align: top;
        background-color: #fff;
        margin-bottom: 20px;
    }

    .right {
        width: 100%;
        vertical-align: top;
        background-color: #fff;
    }

    .cate {
        padding: 10px;
        font-size: 14px;
    }

    .cate-content {
        line-height: 2;
        cursor: pointer;
        display: inline-block;
        text-align: center;
        padding: 0;
        margin-right: 20px;
    }

    .content {
        padding: 15px;
        line-height: 2;
        font-size: 16px;
        overflow-x: auto;
    }

    /deep/ .content img {
        max-width: 100% !important;
    }

    .active {
        color: #a0ca32;
        font-weight: 700;
        border-bottom: 3px solid #a0ca32;
    }

    .title {
        width: calc(100% - 40px);
        padding: 20px;
        font-size: 18px;
        font-weight: 700;
    }

    .time {
        font-size: 14px;
        font-weight: 400;
        margin-top: 10px;
        color: #666;
    }

    .time span {
        margin-right: 50px;
    }

    .type {
        background-color: #a0ca32;
        padding: 3px 5px;
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        border-radius: 5px;
    }
    .match{
        text-align: center;
        background-color: #a0ca32;
        color: #fff;
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 15px;
        cursor:pointer;
        width: calc(100% - 40px);
        margin: 0 20px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        margin-top: 20px;
    }
</style>